import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle, LogOut } from "lucide-react";
import { api, formatApiError } from "@/api/client";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

/** Persistent banner shown while a platform_owner is impersonating another user.
 * Detection is driven by the backend `/auth/me`.impersonated_by field so it survives
 * full page reloads (window globals are wiped on window.location.replace).
 */
export function ImpersonationBanner() {
    const { t } = useTranslation();
    const { me, refresh } = useAuth();
    const [busy, setBusy] = useState(false);
    const imp = (me as any)?.impersonated_by;
    if (!imp) return null;
    const targetName = me?.user.full_name || me?.user.email || "";
    const end = async () => {
        setBusy(true);
        try {
            await api.post("/platform/impersonate/end");
            (window as any).__eduerp_impersonation__ = null;
            await refresh();
            window.location.replace("/platform");
        } catch (e: any) { toast.error(formatApiError(e)); setBusy(false); }
    };
    return (
        <div data-testid="impersonation-banner"
            className="flex items-center gap-3 px-4 py-2 text-sm font-medium border-b"
            style={{ background: "var(--error-bg)", color: "var(--error-fg)", borderColor: "var(--border)" }}>
            <AlertTriangle size={16} />
            <span className="flex-1" data-testid="impersonation-banner-text">
                {t("platform.impersonate.banner", { name: targetName })}
                <span className="opacity-70 ml-2">· {t("platform.impersonate.by", { owner: imp.email })}</span>
            </span>
            <button data-testid="impersonation-end" onClick={end} disabled={busy}
                className="inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium border"
                style={{ background: "var(--card)", color: "var(--text)", borderColor: "var(--border)" }}>
                <LogOut size={14} />{t("platform.impersonate.end")}
            </button>
        </div>
    );
}
